export enum InputType {
  TEXT = 'text',
  LONG_TEXT = 'long_text',
  EMAIL = 'email',
  PHONE = 'tel',
  URL = 'url',
  SEARCH = 'search',
  NUMBER = 'number',
  SELECT = 'select',
  SELECT_WITH_ENUM = 'SELECT_WITH_ENUM',
  MULTISELECT = 'multiselect',
  MULTISELECT_SCROLL = 'multiselect_scroll',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  INFINITE_SCROLL = 'select2',
  SELECT_SEARCH = 'select_search',
  SEATS = 'SEATS',
  CONVERTIBLE_SEATS = 'CONVERTIBLE_SEATS',
  TIME = 'TIME',
  AUTOCOMPLETE_SEARCH = 'autocomplete_search',
  COLOR = 'COLOR',
  MULTISELECT_CHECKBOXES = 'MULTISELECT_CHECKBOXES',
  RANGE_DATE = 'RANGE_DATE',
  TOGGLE = 'TOGGLE',
}
